// Contenus des pages légales (mentions légales, politique de confidentialité, CGV)
// Chaque section : { heading, paragraphs: [], list: [] }

export const legalDocs = {
  'mentions-legales': {
    title: 'Mentions légales',
    updated: '17 septembre 2026',
    metaDescription: 'Mentions légales du site lynko.info — Lynko, Yanis GARI, entrepreneur individuel, Saint-Priest. Éditeur, hébergement, propriété intellectuelle.',
    sections: [
      {
        heading: '1. Éditeur du site',
        paragraphs: [
          "Le présent site internet, accessible à l'adresse https://lynko.info, est édité par :",
        ],
        list: [
          'Yanis GARI – Entrepreneur individuel sous le régime de la micro-entreprise',
          'Nom commercial : Lynko',
          'SIRET : 850 159 757 00036',
          'SIREN : 850 159 757',
          'Adresse professionnelle : 16 rue Anatole France, 69800 Saint-Priest, France',
          'E-mail : adminyg@lynko.info',
          'Téléphone : 07 49 45 13 45',
          'Directeur de la publication : Yanis GARI',
        ],
      },
      {
        heading: '2. Hébergement',
        paragraphs: ['Le site lynko.info est hébergé par :'],
        list: [
          'IONOS SE',
          'Elgendorfer Straße 57',
          '56410 Montabaur',
          'Allemagne',
          'Site internet : https://www.ionos.fr/',
        ],
      },
      {
        heading: '3. Activité',
        paragraphs: ['Lynko propose exclusivement aux professionnels des prestations de services informatiques, notamment :'],
        list: [
          "installation et configuration de postes informatiques ;",
          "installation et configuration d'imprimantes ;",
          'mise en réseau et raccordement des équipements ;',
          'configuration de réseaux informatiques ;',
          'installation et configuration de solutions de téléphonie IP ;',
          'dépannage et assistance informatique ;',
          'maintenance et supervision informatique ;',
          'sauvegarde et protection des données ;',
          'conseil et accompagnement informatique.',
        ],
        afterList: [
          'Les prestations peuvent être réalisées à distance ou sur site selon leur nature et les conditions définies avec le client.',
        ],
      },
      {
        heading: '4. Propriété intellectuelle',
        paragraphs: [
          "L'ensemble des éléments présents sur le site lynko.info, notamment les textes, contenus, graphismes, logos, éléments visuels, icônes et structure du site, est protégé par les dispositions applicables en matière de propriété intellectuelle.",
          "Sauf indication contraire, ces éléments sont la propriété de Lynko ou sont utilisés avec l'autorisation de leurs titulaires.",
          "Toute reproduction, représentation, modification, adaptation ou exploitation, totale ou partielle, sans autorisation préalable, est interdite, sauf dans les limites prévues par la loi.",
        ],
      },
      {
        heading: '5. Responsabilité',
        paragraphs: [
          "Lynko s'efforce de maintenir sur son site des informations exactes et à jour.",
          "Toutefois, Lynko ne garantit pas l'exhaustivité ou l'absence d'erreur dans les informations présentées.",
          "L'utilisation des informations disponibles sur le site relève de la responsabilité de l'utilisateur.",
          "Lynko ne pourra être tenue responsable des dommages résultant de l'utilisation du site ou de son indisponibilité temporaire.",
        ],
      },
      {
        heading: '6. Liens vers des sites tiers',
        paragraphs: [
          'Le site peut contenir des liens vers des sites ou services exploités par des tiers.',
          "Lynko n'exerce aucun contrôle sur ces sites et ne peut être tenue responsable de leur contenu, de leur disponibilité ou de leurs pratiques.",
        ],
      },
      {
        heading: '7. Données personnelles',
        paragraphs: [
          'Les informations relatives au traitement des données personnelles sont détaillées dans la Politique de confidentialité accessible depuis le site.',
        ],
      },
      {
        heading: '8. Cookies',
        paragraphs: [
          "Le site peut utiliser des cookies ou autres traceurs nécessaires à son fonctionnement ou, le cas échéant, à certaines fonctionnalités.",
          "Lorsque le consentement de l'utilisateur est requis, celui-ci est recueilli conformément à la réglementation applicable.",
        ],
      },
      {
        heading: '9. Droit applicable',
        paragraphs: [
          'Le présent site est soumis au droit français.',
          "Pour toute question relative au site, vous pouvez contacter Lynko à l'adresse : adminyg@lynko.info",
        ],
      },
    ],
  },

  'politique-de-confidentialite': {
    title: 'Politique de confidentialité',
    updated: '17 septembre 2026',
    metaDescription: 'Politique de confidentialité de Lynko : données collectées via lynko.info, finalités, durées de conservation, vos droits (RGPD).',
    intro: [
      'Lynko accorde une importance particulière à la protection des données personnelles et au respect de la vie privée.',
      "La présente politique explique quelles données personnelles peuvent être collectées via le site https://lynko.info, dans quelles conditions elles sont utilisées et quels sont les droits des personnes concernées.",
    ],
    sections: [
      {
        heading: '1. Responsable du traitement',
        paragraphs: ['Le responsable des traitements de données personnelles réalisés dans le cadre du site est :'],
        list: [
          'Yanis GARI – Entrepreneur individuel',
          'Nom commercial : Lynko',
          '16 rue Anatole France',
          '69800 Saint-Priest',
          'France',
          'SIRET : 850 159 757 00036',
          'E-mail : adminyg@lynko.info',
          'Téléphone : 07 49 45 13 45',
        ],
      },
      {
        heading: '2. Données collectées',
        paragraphs: ['Selon les services utilisés sur le site, Lynko peut collecter notamment :'],
        list: [
          'nom et prénom ;',
          "nom de l'entreprise ;",
          'adresse e-mail professionnelle ;',
          'numéro de téléphone ;',
          'contenu de la demande adressée à Lynko ;',
          "informations nécessaires à l'établissement d'un devis ;",
          'informations nécessaires à la gestion de la relation commerciale ;',
          'données techniques nécessaires au fonctionnement et à la sécurité du site.',
        ],
        afterList: ['Lynko limite la collecte aux données nécessaires aux finalités poursuivies.'],
      },
      {
        heading: '3. Formulaire de contact',
        paragraphs: ['Les informations transmises via le formulaire de contact sont utilisées afin de :'],
        list: [
          'répondre aux demandes des professionnels ;',
          'contacter le demandeur lorsque cela est nécessaire ;',
          "comprendre le besoin exprimé ;",
          'préparer un devis ou une proposition commerciale ;',
          "assurer le suivi d'une demande commerciale.",
        ],
        afterList: [
          "Le traitement repose notamment sur l'intérêt légitime de Lynko pour répondre aux demandes reçues et, lorsque cela est applicable, sur les mesures précontractuelles prises à la demande du prospect.",
        ],
      },
      {
        heading: '4. Gestion de la relation commerciale',
        paragraphs: ["Lorsqu'un professionnel devient client de Lynko, certaines données peuvent être utilisées afin de :"],
        list: [
          'établir les devis et factures ;',
          'gérer les commandes ;',
          'assurer le suivi des prestations ;',
          'gérer les contrats de maintenance ;',
          'assurer les échanges nécessaires à la réalisation des prestations ;',
          'gérer les paiements ;',
          'respecter les obligations légales, comptables et fiscales applicables.',
        ],
      },
      {
        heading: '5. Destinataires des données',
        paragraphs: ['Les données personnelles peuvent être accessibles, uniquement lorsque cela est nécessaire :'],
        list: [
          'à Yanis GARI / Lynko ;',
          'aux prestataires techniques nécessaires au fonctionnement du site ;',
          "aux prestataires nécessaires à l'exécution des prestations ;",
          'aux prestataires administratifs ou comptables lorsque cela est nécessaire ;',
          "aux autorités compétentes lorsque la loi l'impose.",
        ],
        afterList: [
          "Lynko veille à ce que les prestataires auxquels elle fait appel présentent des garanties appropriées en matière de protection des données.",
        ],
      },
      {
        heading: '6. Prestataires techniques',
        paragraphs: [
          "Le fonctionnement du site et des prestations de Lynko peut nécessiter l'utilisation de services fournis par des tiers, notamment pour :",
        ],
        list: [
          "l'hébergement du site ;",
          'les communications électroniques ;',
          'la gestion informatique ;',
          'la maintenance ;',
          'les services de sauvegarde ;',
          'le stockage de données ;',
          'les outils de gestion commerciale.',
        ],
        afterList: [
          'Lorsque ces prestataires traitent des données personnelles pour le compte de Lynko, les relations sont encadrées conformément à la réglementation applicable.',
        ],
      },
      {
        heading: '7. Données traitées dans le cadre des prestations informatiques',
        paragraphs: [
          "Lorsque Lynko intervient directement sur les systèmes informatiques d'un client, elle peut être amenée à accéder techniquement à certaines données présentes sur les équipements concernés.",
          "Cet accès intervient uniquement dans le cadre de la prestation demandée et dans la mesure nécessaire à sa réalisation.",
          "Lorsque Lynko traite des données personnelles pour le compte d'un client professionnel, notamment dans le cadre d'une prestation de maintenance, de sauvegarde ou d'administration informatique, les rôles et obligations respectifs des parties sont déterminés conformément au RGPD et, lorsque nécessaire, par des dispositions contractuelles spécifiques.",
        ],
      },
      {
        heading: '8. Durée de conservation',
        paragraphs: [
          "Les données sont conservées pendant une durée n'excédant pas celle nécessaire aux finalités pour lesquelles elles sont traitées, sous réserve des obligations légales de conservation.",
          "Les données relatives aux demandes de contact sont conservées pendant la durée nécessaire à leur traitement et, lorsque cela est pertinent, pendant une durée permettant d'assurer le suivi commercial.",
          "Les données relatives aux clients et aux prestations sont conservées pendant la durée de la relation commerciale puis pendant les durées nécessaires au respect des obligations légales.",
          'Certaines données comptables, contractuelles ou administratives peuvent être conservées pendant les durées imposées par la réglementation.',
        ],
      },
      {
        heading: '9. Sécurité',
        paragraphs: [
          "Lynko met en œuvre des mesures techniques et organisationnelles appropriées afin de protéger les données personnelles contre les accès non autorisés, la perte, la destruction, la modification ou la divulgation non autorisée.",
        ],
      },
      {
        heading: '10. Cookies',
        paragraphs: [
          'Le site peut utiliser des cookies ou traceurs nécessaires à son fonctionnement.',
          "Lorsque des cookies ou traceurs nécessitent le consentement de l'utilisateur, ils ne sont utilisés qu'après obtention de celui-ci.",
          "L'utilisateur peut gérer ses préférences lorsque le site met à disposition un dispositif de gestion du consentement.",
        ],
      },
      {
        heading: '11. Vos droits',
        paragraphs: ['Conformément à la réglementation applicable, vous pouvez, selon les conditions prévues par celle-ci :'],
        list: [
          'accéder à vos données personnelles ;',
          'demander leur rectification ;',
          'demander leur effacement ;',
          'demander la limitation du traitement ;',
          'vous opposer à certains traitements ;',
          'demander la portabilité de vos données lorsque ce droit est applicable ;',
          "retirer votre consentement lorsqu'un traitement repose sur celui-ci.",
        ],
        afterList: [
          'Pour exercer vos droits : adminyg@lynko.info',
          'Vous pouvez également écrire à : Yanis GARI – Lynko, 16 rue Anatole France, 69800 Saint-Priest, France.',
          "Lynko peut demander un justificatif d'identité lorsque cela est nécessaire pour vérifier l'identité du demandeur.",
        ],
      },
      {
        heading: '12. Réclamation auprès de la CNIL',
        paragraphs: [
          "Si vous estimez, après avoir contacté Lynko, que vos droits ne sont pas respectés, vous pouvez adresser une réclamation à la Commission nationale de l'informatique et des libertés (CNIL).",
        ],
      },
      {
        heading: "13. Transferts hors de l'Union européenne",
        paragraphs: [
          'Certains prestataires utilisés par Lynko peuvent être établis hors de l\'Union européenne ou utiliser des infrastructures situées dans des pays tiers.',
          "Lorsque des données personnelles sont transférées hors de l'Union européenne, Lynko veille à ce que ces transferts soient encadrés conformément au RGPD.",
        ],
      },
      {
        heading: '14. Modification de la politique',
        paragraphs: [
          'Lynko peut modifier la présente politique afin de tenir compte de l\'évolution de ses services, de son site ou de la réglementation applicable.',
          'La version publiée sur le site est la version en vigueur.',
        ],
      },
    ],
  },

  'cgv': {
    title: 'Conditions générales de vente',
    updated: '17 septembre 2026',
    metaDescription: 'Conditions générales de vente de Lynko : prestations informatiques pour professionnels, devis, prix, paiement, maintenance, responsabilité.',
    sections: [
      {
        heading: 'Article 1 — Objet',
        paragraphs: [
          "Les présentes Conditions Générales de Vente (CGV) définissent les conditions dans lesquelles Yanis GARI, entrepreneur individuel exerçant sous le nom commercial Lynko, fournit des prestations de services informatiques exclusivement à des clients professionnels.",
          "Elles s'appliquent notamment aux prestations d'installation, de dépannage, de maintenance, de réseau, de téléphonie IP, de sauvegarde et d'assistance informatique.",
          'Les conditions particulières figurant sur un devis, une proposition commerciale ou un contrat spécifique peuvent compléter ou modifier les présentes CGV.',
        ],
      },
      {
        heading: 'Article 2 — Prestations',
        paragraphs: ['Lynko propose notamment les prestations suivantes :'],
        subBlocks: [
          {
            title: 'Installation informatique',
            list: [
              'installation et configuration de postes informatiques ;',
              'installation de logiciels ;',
              'configuration des comptes utilisateurs ;',
              'optimisation et mise en service des équipements.',
            ],
          },
          {
            title: "Installation d'imprimantes",
            list: [
              'installation des pilotes ;',
              'configuration réseau ;',
              "partage d'imprimantes ;",
              'configuration sur les postes utilisateurs.',
            ],
          },
          {
            title: 'Réseau informatique',
            list: [
              'configuration de routeurs et pare-feu ;',
              'configuration de switches ;',
              'configuration Wi-Fi ;',
              'mise en réseau des équipements ;',
              'raccordement et brassage ;',
              'configuration de VLAN et autres paramètres réseau lorsque prévus.',
            ],
            afterList: [
              'Les travaux de passage ou de création de câbles dans les murs, plafonds, cloisons, gaines ou autres structures du bâtiment ne sont pas inclus sauf mention expresse dans le devis.',
              'Ces travaux peuvent, si nécessaire, être réalisés par un professionnel spécialisé.',
            ],
          },
          {
            title: 'Téléphonie IP',
            paragraphs: ['Lynko peut réaliser :'],
            list: [
              'l\'installation de téléphones IP ;',
              "la configuration d'IPBX ;",
              'la configuration de comptes SIP ;',
              "la configuration d'extensions ;",
              "la configuration d'équipements DECT IP ;",
              'les tests de fonctionnement.',
            ],
            afterList: [
              "Les abonnements télécom, licences, numéros et services fournis par des opérateurs tiers ne sont inclus que lorsqu'ils sont expressément mentionnés dans le devis.",
            ],
          },
          {
            title: 'Dépannage et support',
            paragraphs: [
              'Les prestations de dépannage peuvent être réalisées à distance ou sur site.',
              "Sauf disposition contraire prévue dans un contrat de maintenance, les interventions sont facturées au temps passé ou selon le devis accepté.",
              "Pour les prestations facturées au temps passé, la première heure est indivisible et toute demi-heure entamée est due.",
            ],
          },
          {
            title: 'Maintenance',
            paragraphs: ['Lynko peut proposer des contrats de maintenance comprenant notamment :'],
            list: [
              'supervision des équipements ;',
              'suivi des mises à jour ;',
              'maintenance préventive ;',
              "détection d'anomalies ;",
              'optimisation des performances ;',
              'assistance à distance ;',
              'rapports et recommandations.',
            ],
            afterList: ['Le périmètre précis des prestations incluses est défini dans le devis ou contrat de maintenance.'],
          },
          {
            title: 'Sauvegarde et protection des données',
            paragraphs: [
              'Lynko peut mettre en place des solutions de sauvegarde locales, cloud ou hybrides.',
              'Selon la solution retenue, les prestations peuvent comprendre :',
            ],
            list: [
              'configuration des sauvegardes ;',
              'surveillance des sauvegardes ;',
              'gestion des versions et de la rétention ;',
              'sauvegarde locale ;',
              'sauvegarde cloud ;',
              'tests de restauration ;',
              'rapports et alertes.',
            ],
            afterList: ['Les modalités précises de sauvegarde sont définies dans le devis ou contrat concerné.'],
          },
        ],
      },
      {
        heading: 'Article 3 — Devis et commande',
        paragraphs: [
          "Lorsque la prestation nécessite un devis, celui-ci précise notamment la nature des prestations, les éventuels matériels fournis, les prix et les conditions particulières applicables.",
          "La commande devient ferme après acceptation du devis par le client et, lorsqu'elle est prévue, après réception du paiement ou de l'acompte demandé.",
          "L'acceptation peut être réalisée par signature, validation électronique ou confirmation écrite.",
        ],
      },
      {
        heading: 'Article 4 — Prix',
        paragraphs: [
          'Les prix sont exprimés en euros.',
          "Lorsque Lynko bénéficie du régime de franchise en base de TVA, les factures portent la mention : « TVA non applicable, art. 293 B du CGI ».",
          'Les tarifs applicables sont ceux indiqués sur le devis accepté ou, pour les prestations sans devis, ceux communiqués au client avant intervention.',
          "Les éventuels frais de déplacement, livraison, licences, abonnements ou services tiers sont facturés lorsqu'ils sont prévus.",
        ],
      },
      {
        heading: 'Article 5 — Commande et paiement du matériel',
        paragraphs: [
          'Tout matériel fourni par Lynko doit être intégralement réglé avant sa commande auprès du fournisseur.',
          'Aucune commande de matériel ne sera passée avant réception du paiement correspondant.',
          "Les délais de livraison annoncés dépendent notamment de la disponibilité du matériel auprès des fournisseurs.",
          "En cas d'indisponibilité d'un produit après paiement, Lynko pourra proposer un produit équivalent ou procéder au remboursement des sommes correspondantes selon les conditions convenues avec le client.",
        ],
      },
      {
        heading: 'Article 6 — Réserve de propriété',
        paragraphs: [
          "Les matériels fournis restent la propriété de Lynko jusqu'au paiement complet de leur prix, conformément aux dispositions légales applicables, notamment la loi n° 80-335 du 12 mai 1980.",
          'En cas de non-paiement, Lynko pourra exercer les droits attachés à cette réserve de propriété conformément à la réglementation en vigueur.',
        ],
      },
      {
        heading: 'Article 7 — Paiement des prestations',
        paragraphs: [
          "Sauf condition particulière prévue au devis ou contrat, les prestations réalisées sont payables dans un délai de 15 jours à compter de la réalisation de la prestation ou de l'émission de la facture, selon la date d'échéance indiquée sur celle-ci.",
          "La date d'échéance figurant sur la facture fait foi.",
          'Pour les prestations récurrentes, les conditions de paiement sont précisées dans le contrat concerné.',
        ],
      },
      {
        heading: 'Article 8 — Retard de paiement',
        paragraphs: [
          "Tout retard de paiement entraîne, sans qu'un rappel soit nécessaire, l'application de pénalités de retard à compter du jour suivant la date d'échéance figurant sur la facture.",
          "Le taux des pénalités de retard est fixé à trois fois le taux d'intérêt légal en vigueur.",
          'Une indemnité forfaitaire de 40 € pour frais de recouvrement est également due pour tout retard de paiement entre professionnels.',
          "Cette indemnité est due de plein droit, sans préjudice d'une indemnisation complémentaire lorsque les frais de recouvrement réellement engagés sont supérieurs à son montant, dans les conditions prévues par la loi.",
        ],
      },
      {
        heading: 'Article 9 — Maintenance',
        paragraphs: [
          "Les contrats de maintenance sont conclus pour une durée d'un an.",
          'Ils sont renouvelables annuellement et sans engagement de reconduction au-delà de la période en cours.',
          "Chaque partie peut mettre fin au contrat à son échéance sous réserve d'un préavis d'un mois.",
          'La demande de résiliation doit être adressée par écrit.',
          "Sauf indication contraire dans le contrat, toute période commencée reste due jusqu'à sa date de fin.",
          'Les prestations ou interventions non comprises dans le périmètre du contrat de maintenance peuvent être facturées séparément.',
        ],
      },
      {
        heading: 'Article 10 — Intervention sur site',
        paragraphs: [
          'Le client doit permettre l\'accès aux locaux et équipements nécessaires à la réalisation de la prestation.',
          "Le client doit également fournir les informations et accès nécessaires à l'intervention.",
          "Une intervention rendue impossible par l'absence d'accès, d'informations ou d'un interlocuteur compétent peut être reportée et, lorsque cela est justifié, facturée selon les conditions prévues.",
        ],
      },
      {
        heading: 'Article 11 — Assistance à distance',
        paragraphs: [
          "Lynko peut utiliser des outils de télémaintenance afin d'assurer certaines prestations.",
          "L'accès à distance est utilisé uniquement pour les besoins de l'intervention ou du contrat concerné.",
          'Le client autorise cet accès dans les conditions convenues avec Lynko.',
        ],
      },
      {
        heading: 'Article 12 — Sauvegardes',
        paragraphs: [
          'Lorsque Lynko met en place une solution de sauvegarde, le périmètre des données protégées, la fréquence, la durée de conservation et la destination des sauvegardes sont définis dans le devis ou contrat.',
          "Lynko recommande la conservation de plusieurs copies sur des environnements distincts lorsque cela est adapté aux besoins du client.",
          'Une sauvegarde ne constitue pas une garantie absolue contre toute perte de données.',
          'Les tests de restauration sont réalisés lorsqu\'ils sont prévus dans la prestation ou demandés par le client.',
        ],
      },
      {
        heading: 'Article 13 — Obligations du client',
        paragraphs: ["Le client s'engage notamment à :"],
        list: [
          "fournir les informations nécessaires à l'intervention ;",
          'fournir les accès nécessaires ;',
          'informer Lynko des contraintes techniques ou réglementaires applicables ;',
          'signaler les équipements ou logiciels critiques ;',
          'ne pas modifier les configurations faisant l\'objet d\'une intervention lorsque cette modification peut compromettre la prestation ;',
          'utiliser les logiciels conformément à leurs licences ;',
          'régler les factures dans les délais.',
        ],
      },
      {
        heading: 'Article 14 — Sécurité informatique',
        paragraphs: [
          'Lynko peut proposer des mesures destinées à améliorer la sécurité des systèmes informatiques du client.',
          "Toutefois, aucune solution informatique ne peut garantir une absence totale de panne, de cyberattaque, de ransomware, de perte de données ou d'incident de sécurité.",
          'Le niveau de protection dépend notamment des équipements, logiciels, services souscrits et pratiques du client.',
        ],
      },
      {
        heading: 'Article 15 — Responsabilité',
        paragraphs: [
          "Lynko est tenue à une obligation de moyens dans l'exécution de ses prestations.",
          'Lynko ne pourra notamment être tenue responsable des conséquences résultant :',
        ],
        list: [
          "d'une panne ou défaillance d'un matériel appartenant au client ;",
          "d'un logiciel ou service tiers ;",
          "d'une panne d'un opérateur télécom ou fournisseur d'accès ;",
          "d'une utilisation non conforme des équipements ;",
          "d'une intervention réalisée par un tiers ;",
          "d'informations incomplètes ou erronées fournies par le client ;",
          "d'un événement indépendant de sa volonté ;",
          "d'une cyberattaque malgré la mise en œuvre des mesures prévues.",
        ],
        afterList: [
          "Lorsque Lynko intervient sur un système existant, elle ne peut garantir l'absence de défauts ou incompatibilités préexistants.",
          'Les limitations de responsabilité prévues au présent article s\'appliquent sous réserve des dispositions légales impératives.',
        ],
      },
      {
        heading: 'Article 16 — Confidentialité',
        paragraphs: [
          "Lynko s'engage à préserver la confidentialité des informations dont elle pourrait avoir connaissance dans le cadre de ses prestations.",
          'Cette obligation concerne notamment les informations techniques, commerciales, organisationnelles et confidentielles communiquées par le client.',
        ],
      },
      {
        heading: 'Article 17 — Données personnelles',
        paragraphs: [
          'Lynko traite les données personnelles conformément à la réglementation applicable.',
          "Lorsque Lynko traite des données personnelles pour le compte du client dans le cadre d'une prestation informatique, les obligations respectives des parties sont déterminées conformément au RGPD et, lorsque nécessaire, par un accord de sous-traitance spécifique.",
          'Le client reste responsable des traitements dont il détermine les finalités et moyens.',
        ],
      },
      {
        heading: 'Article 18 — Services et fournisseurs tiers',
        paragraphs: [
          'Certaines prestations peuvent nécessiter l\'utilisation de services fournis par des tiers, notamment :',
        ],
        list: [
          'opérateurs télécom ;',
          "fournisseurs d'accès internet ;",
          'éditeurs de logiciels ;',
          'fournisseurs cloud ;',
          'fournisseurs de sauvegarde ;',
          'fabricants de matériel.',
        ],
        afterList: [
          'Les services de ces tiers peuvent être soumis à leurs propres conditions contractuelles.',
          "Lynko ne peut garantir la disponibilité ou la continuité d'un service dont elle ne maîtrise pas l'exploitation.",
        ],
      },
      {
        heading: 'Article 19 — Délais',
        paragraphs: [
          'Les délais communiqués par Lynko sont indicatifs sauf engagement expressément prévu dans le devis ou contrat.',
          "Ils peuvent notamment dépendre de la disponibilité du matériel, des fournisseurs, des éditeurs, de l'accès aux locaux ou de la complexité de l'intervention.",
        ],
      },
      {
        heading: 'Article 20 — Force majeure',
        paragraphs: [
          "Lynko ne pourra être tenue responsable d'un retard ou d'une inexécution résultant d'un événement de force majeure au sens du droit français.",
        ],
      },
      {
        heading: 'Article 21 — Résiliation',
        paragraphs: [
          "En cas de manquement grave d'une partie à ses obligations contractuelles, l'autre partie pourra demander la résiliation du contrat dans les conditions prévues par la loi et, le cas échéant, par le contrat concerné.",
          'Les prestations déjà réalisées restent dues.',
        ],
      },
      {
        heading: 'Article 22 — Réclamations',
        paragraphs: [
          'Toute réclamation doit être adressée à Lynko dans les meilleurs délais afin de permettre son analyse et sa résolution lorsque celle-ci est possible.',
          'Les réclamations peuvent être adressées à : adminyg@lynko.info',
          'Ou par courrier à : Yanis GARI – Lynko, 16 rue Anatole France, 69800 Saint-Priest, France.',
        ],
      },
      {
        heading: 'Article 23 — Droit applicable et règlement des litiges',
        paragraphs: [
          'Les présentes CGV sont soumises au droit français.',
          'En cas de différend, les parties s\'efforceront de rechercher une solution amiable.',
          "À défaut d'accord amiable, le litige sera soumis aux juridictions compétentes conformément aux règles de droit commun applicables.",
        ],
      },
      {
        heading: 'Article 24 — Acceptation des CGV',
        paragraphs: [
          "L'acceptation d'un devis, d'une commande ou d'un contrat implique l'acceptation sans réserve des présentes CGV, sauf conditions particulières expressément convenues entre Lynko et le client.",
          'En cas de contradiction entre les présentes CGV et les conditions particulières d\'un devis ou contrat, les conditions particulières prévalent.',
        ],
      },
    ],
  },
};
